import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { MainContext } from "../../../../../MainContext";
import { convertToApproximateString } from "../../../Inputs/convert";
import { useMediaQuery, useTheme } from "@mui/material";
import { request } from "../../../../../request";

function formatDate(date) {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const yyyy = date.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
}

export const BoundableTransactionSelector = ({ toBeBounded, setToBeBounded, selectedBound, setSelectedBound, selectedCustomer, getFilteredHistory }) => {
    const { boundableTransactions, accounts, updateTransactions } = useContext(MainContext);
    const [options, setOptions] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        if (selectedCustomer) {
            const my_option = options.find((opt) => opt.value.customerId === selectedCustomer.toString());
            if (my_option) {
                setSelectedBound(my_option);
            }
        }
    }, [selectedCustomer]);
    useEffect(() => {
        const opted_transactions = [];
        boundableTransactions.forEach((jt) => {
            opted_transactions.push({
                customerId: jt.customerId,
                customerName: jt.customerName,
                transactions: jt.transactions_full,
                value: 0,
                data: jt,
            });
        });
        opted_transactions.forEach((option, index) => {
            option.transactions.map((t) => {
                if (t?.from[0].place.accountId) {
                    const value = t?.from[0].amount * t?.from[0].avg;
                    opted_transactions[index].value -= value;
                } else if (t?.to[0].place.accountId) {
                    if (t?.to[0].commingAvg) {
                        console.log(t.timeStamp, t?.to[0].commingAvg);
                        console.log(t);
                        const value = t?.to[0].amount * t?.to[0].commingAvg;
                        opted_transactions[index].value += value;
                    } else {
                        const value = t?.to[0].amount * t?.to[0].avg;
                        opted_transactions[index].value += value;
                    }
                }
            });
        });
        setOptions(
            opted_transactions.map((option, index) => {
                return {
                    value: option,
                    searchLabel: option.customerName,
                    label: (
                        <div>
                            <strong>
                                {option.customerName} <span style={{ color: option.value > 0 ? "green" : "red" }}>{convertToApproximateString(option.value)} AMD</span>
                            </strong>
                            <br />
                            {option.transactions.map((t) => {
                                if (t?.from[0].place.accountId) {
                                    const value = t?.from[0].amount * (t?.from[0].commingAvg || t?.from[0].avg);
                                    return (
                                        <>
                                            <small style={{ color: "red" }}>
                                                -{convertToApproximateString(value)} AMD ({t?.from[0].amount}
                                                {t?.from[0].currency_name}) {accounts.find((a) => a._id === t.from[0].place.accountId)?.name} {formatDate(new Date(t.timeStamp))}
                                            </small>
                                            <br />
                                        </>
                                    );
                                } else if (t?.to[0].place.accountId) {
                                    const value = t?.to[0].amount * (t?.to[0].commingAvg || t?.to[0].avg);
                                    return (
                                        <>
                                            <small style={{ color: "green" }}>
                                                +{convertToApproximateString(value)} AMD ({t?.to[0].amount}
                                                {t?.to[0].currency_name}) {accounts.find((a) => a._id === t.to[0].place.accountId)?.name} {formatDate(new Date(t.timeStamp))}
                                            </small>
                                            <br />
                                        </>
                                    );
                                }
                            })}
                        </div>
                    ),
                };
            })
        );
    }, [boundableTransactions]);

    return (
        <div className="wp-full max-w-[960px] mb-10 px-15">
            {setToBeBounded && (
                <label
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: "pointer",
                        marginTop: isMobile ? "50px" : "16px",
                    }}
                >
                    <input type="checkbox" checked={toBeBounded} onChange={() => setToBeBounded(!toBeBounded)} className="hidden" />
                    <span className={`w-6 h-6 flex items-center justify-center border-2 border-gray-400 rounded transition-colors ${toBeBounded ? "bg-blue-500 border-blue-500" : "bg-white"}`}>
                        {toBeBounded && (
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" clipRule="evenodd" />
                            </svg>
                        )}
                    </span>
                    <span className="ml-2 text-gray-700" style={{ color: "white" }}>
                        Bound
                    </span>
                </label>
            )}
            {toBeBounded && (
                <>
                    <Select
                        options={options}
                        isClearable
                        isSearchable
                        isLoading={!boundableTransactions.length}
                        value={selectedBound}
                        onChange={(selectedOption) => {
                            setSelectedBound(selectedOption);
                        }}
                        placeholder="Choose Bound..."
                        getOptionLabel={(e) => <div style={{ display: "flex", flexDirection: "column" }}>{e.label}</div>}
                        getOptionValue={(e) => e.searchLabel}
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: "gray",
                                borderRadius: "0.375rem",
                                padding: "0.375rem",
                                boxShadow: "none",
                                "&:hover": { borderColor: "blue" },
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? "#FEC901" : state.isFocused ? "lightgray" : "white",
                                color: state.isSelected ? "black" : "black",
                                "&:hover": {
                                    backgroundColor: "lightblue",
                                },
                            }),
                            menu: (base) => ({
                                ...base,
                                marginTop: 0,
                                borderRadius: "0.375rem",
                            }),
                            placeholder: (base) => ({
                                ...base,
                                color: "gray",
                                fontSize: "0.875rem",
                            }),
                        }}
                    />
                </>
            )}
            {selectedBound && window.localStorage.getItem("login") == "root" && (
                <button
                    type="button"
                    onClick={() =>
                        request.post("/transaction/delete-bound", { joined_transaction_id: selectedBound.value.data.joined_transaction_id }).then(() => {
                            alert("ok");
                            getFilteredHistory();
                            updateTransactions();
                            setSelectedBound(null);
                        })
                    }
                    style={{ backgroundColor: "white", margin: "10px 0", borderRadius: "5px", padding: "5px" }}
                >
                    Delete
                </button>
            )}
        </div>
    );
};
